import { ApiFragment } from '../../core/records/entities/api-fragment.class';
import { AI_STATUS_FIELD_DEFINITION_DOTTED_KEY } from '../constants/field-definition-keys.constants';

const [family, property] = AI_STATUS_FIELD_DEFINITION_DOTTED_KEY.split('.');

export function GetRecordAiStatus(record: ApiFragment): string | null {
    return record.get(family, property);
}

export function SetRecordAiStatus(record: ApiFragment, aiRecord: ApiFragment): ApiFragment {
    const aiStatus: string | null = aiRecord.get(family, property);
    record.set(family, property, aiStatus);

    return record;
}
